
const getUserSessionLogin = () => {
    return sessionStorage.getItem('email')
}

const setUserSessionLogin = (email) => {
    sessionStorage.setItem('email', email)
}

export {
    getUserSessionLogin,
    setUserSessionLogin,
}
